import React, { useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { FiCamera } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';

import { FormValues } from '../../Interfaces';
import { applyMrzToShareholder } from './mapMrzToForm';
import { PassportMrzScanModal } from './PassportMrzScanModal';
import { usePassportCamera } from './usePassportCamera';

type ScanPassportControlProps = {
  index: number;
  setValue: UseFormSetValue<FormValues>;
  primaryColor: string;
};

export const ScanPassportControl: React.FC<ScanPassportControlProps> = ({ index, setValue, primaryColor }) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const camera = usePassportCamera();

  const handleOpen = () => {
    setOpen(true);
    void camera.start();
  };

  const handleOpenChange = (nextOpen: boolean) => {
    setOpen(nextOpen);
    if (!nextOpen) {
      camera.stop();
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleOpen}
        className="inline-flex items-center gap-1.5 rounded-lg border bg-white px-3 py-1.5 text-xs font-semibold transition hover:bg-slate-50"
        style={{ color: primaryColor, borderColor: `${primaryColor}33` }}
      >
        <FiCamera size={14} />
        {t('labels.lblScanPassport')}
      </button>
      <PassportMrzScanModal
        open={open}
        onOpenChange={handleOpenChange}
        primaryColor={primaryColor}
        camera={camera}
        onSuccess={(fields) => applyMrzToShareholder(setValue, index, fields)}
      />
    </>
  );
};
